import React, { memo } from "react";
import admin_login from "../../../../assets/images/admin_login.png";
import { MessageHeaderMain, UserAvatar } from "../styles/MessagesStyles";

const MessageHeader = ({ UserImgUrl = "", UserName = "" }) => {
  return (
    <MessageHeaderMain>
      <UserAvatar alt="userimage" src={UserImgUrl || admin_login} />
      <span>{UserName}</span>
    </MessageHeaderMain>
  );
};

export default memo(MessageHeader);
